import api from 'api';

import { defaultPagination } from './general';

type GetChecklistType = {id: number | string}

export const listChecklists = async (params) => api().get('/checklists', { params: { ...defaultPagination, ...params } });
export const listChecklistExecutions = async (params) => api().get('/checklists/executions', { params: { ...defaultPagination, ...params } });

export const getChecklist = async ({ id }: GetChecklistType) => api().get(`/checklists/${id}`);

export const updateChecklist = async ({ id, data }: any) => api().put(`/checklists/${id}`, data);

export const createChecklist = async ({ data }: any) => api().post('/checklists', data);
